<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <material-card
          color="secondary"
          title="Faturas Individualizadas"
          text=""
        >
          <v-flex class="pl-2 pt-1" style="height: 100vh" v-if="loading">
            <v-layout align-center justify-center row fill-height>
              <v-progress-circular
                indeterminate
                color="#c0c0c0"
              ></v-progress-circular>
            </v-layout>
          </v-flex>
          <v-form ref="form" v-model="valid" lazy-validation v-if="!loading">
            <v-container>
              <v-layout>
                <v-flex xs3 md3 class="text-lg-left">
                  <v-text-field
                    v-model="name"
                    label="Nome"
                    class="purple-input"
                    @keyup.enter="_search"
                  />
                </v-flex>
                <v-flex xs3 md3 class="text-lg-left">
                  <v-text-field
                    v-model="email"
                    label="Email"
                    class="purple-input"
                    @keyup.enter="_search"
                  />
                </v-flex>
                <v-flex xs3 md3 class="text-lg-left">
                  <v-autocomplete
                    :items="statusList"
                    item-text="text"
                    item-value="value"
                    prepend-icon="flash_on"
                    label="Status"
                    v-model="status"
                    @keyup.enter="_search"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs3 md3 class="text-lg-left">
                  <v-btn
                    color="success"
                    small
                    outline
                    slot="start"
                    @click="_search"
                    :disabled="!valid || loading_search"
                    :loading="loading_search"
                  >
                    <v-icon left>search</v-icon>Buscar
                  </v-btn>
                </v-flex>
                <v-flex xs3 md3 class="text-lg-left">
                  <v-btn
                    color="tertiary"
                    small
                    outline
                    slot="start"
                    @click="_clear(true)"
                    :disabled="!valid || loading_search"
                  >
                    <v-icon left>clear</v-icon>Limpar
                  </v-btn>
                </v-flex>
                <v-flex xs3 md3 class="text-lg-right">
                  <div
                    class="text-xs-rigth text-md-rigth text-lg-rigth"
                    v-if="items.length > 0"
                  >
                    <v-btn
                      color="primary"
                      small
                      outline
                      slot="start"
                      @click="_export(items)"
                    >
                      <v-icon left>mdi-file-excel</v-icon>Exportar
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-data-table
            dense
            light
            :headers="headers"
            :items="items"
            :pagination.sync="pagination"
            :total-items="totalItems"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
            :rows-per-page-items="rowsPerPageItems"
            rows-per-page-text="Linhas por página"
            :loading="loading"
            no-data-text="Não há faturas para essa competencia"
            v-if="!loading"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading text-xs-right font-weight-light text-success text--dar n-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td
                v-if="item.status === 'activated'"
                @click.prevent="gotoUserDetail(item)"
              >
                {{ item.name | formatName }}
              </td>
              <td
                v-else
                :class="item.status"
                @click.prevent="gotoUserDetail(item)"
              >
                {{ item.name | formatName }}
              </td>
              <td class="text-xs-right">
                {{ item.billing ? item.billing.amount_kW : 0 | formatCurrency }}
              </td>
              <td class="text-xs-right">
                {{ item.percentage || 0 | formatPercent }}%
              </td>
              <td class="text-xs-right">
                R$ {{ item.billing ? item.billing.tarifa : 0 | formatCurrency }}
              </td>
              <td class="text-xs-right">
                R$
                {{
                  item.billing ? item.billing.custo_disp : 0 | formatCurrency
                }}
              </td>
              <td class="text-xs-right">
                R$ {{ item.billing ? item.billing.total : 0 | formatCurrency }}
              </td>

              <!-- Para faturas antes de 07/2019 - Antes da Mudança para Pagarme -->
              <!-- <td class="text-xs-right" v-if="item.billing.transaction && item.billing.competence < '2019-07'">R$ {{ item.billing.transaction?(item.billing.transaction.cost):0 || 0 | formatCurrency}}</td>
                            <td class="text-xs-right" v-if="item.billing.transaction && item.billing.competence < '2019-07'">R$ {{ item.billing.transaction?(item.billing.total - item.billing.transaction.cost):0 || 0 | formatCurrency}}</td>
                            <td class="text-xs-center" v-if="!item.billing.transaction && item.billing.competence < '2019-07'">-</td> -->

              <!-- Para faturas de 07/2019 em diante - Após Mudança para Pagarme -->
              <!-- <td class="text-xs-right" v-if="item.billing.transactionPagarme && item.billing.competence >= '2019-07'">R$ {{ sumFee(item.billing.transactionPagarme.payables) + (item.billing.transactionPagarme.payment_method === 'credit_card'?item.billing.transactionPagarme.cost/100:0)  | formatCurrency }}</td>
                            <td class="text-xs-right" v-if="item.billing.transactionPagarme && item.billing.competence >= '2019-07'">R$ {{ item.billing.transactionPagarme?item.billing.total - (sumFee(item.billing.transactionPagarme.payables) + (item.billing.transactionPagarme.payment_method === 'credit_card'?(item.billing.transactionPagarme.cost/100):0)):0 || 0 | formatCurrency}}</td>
                            <td class="text-xs-center" v-if="!item.billing.transactionPagarme && item.billing.competence >= '2019-07'">-</td> -->

              <td class="text-xs-right">
                R$
                {{ item.billing ? item.billing.discount : 0 | formatCurrency }}
              </td>
              <td class="text-xs-center">
                {{ item.next_read | formatNextRead }}
              </td>
              <td
                class="text-xs-right"
                v-if="item.billing && item.billing.transaction"
              >
                <v-icon
                  @click.prevent="gotoTransactionHistory(item.billing.id)"
                  >{{
                    item.billing.transaction
                      ? item.billing.transaction.payment_method
                      : "" || "" | formatPaymentType
                  }}</v-icon
                >
              </td>
              <td class="text-xs-right" v-else>-</td>
              <!-- <td class="text-xs-right">
                                <a :href="url(item)" target="_blank"><v-icon>mdi-whatsapp</v-icon></a>
                            </td> -->
              <td
                class="text-xs-right"
                v-if="item.billing && item.billing.transaction"
              >
                <v-icon
                  :color="formatColor(item.billing)"
                  v-if="
                    item.billing.status !== 'paga' &&
                    item.billing.status !== 'succeeded' &&
                    item.billing.status !== 'paid'
                  "
                  @click.prevent="gotoTransactionHistory(item.billing.id)"
                  >{{ item.billing.status | formatStatus }}</v-icon
                >
                <v-icon
                  color="primary"
                  v-else
                  @click.prevent="gotoTransactionHistory(item.billing.id)"
                  >{{ item.billing.status | formatStatus }}</v-icon
                >
              </td>
              <td class="text-xs-right" v-else>-</td>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="error" icon="warning">
                Nenhuma fatura encontrada :(
              </v-alert>
            </template>
            <template v-slot:pageText="items"
              >Linhas {{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }}
            </template>
            <template v-slot:loading>
              <v-progress-linear
                v-if="loading"
                height="2"
                color="blue"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:loading_search>
              <v-progress-linear
                v-if="loading_search"
                height="2"
                color="blue"
                indeterminate
              ></v-progress-linear>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
// import { EventBus } from '../../utils/event-bus'
import XLSX from "xlsx";
import moment from "moment";
import { eventBus } from "../../main";
import firestore from "../../firebase/firestore";

export default {
  name: "InvoiceItensCompetence",
  //props: ['items', 'total'],
  data: () => ({
    loading: false,
    loading_search: false,
    dialog: false,
    valid: false,
    totalItems: 0,
    totalItemsInitial: 0,
    totalItemsProcess: 0,
    pagination: {
      rowsPerPage: 25, // -1 for All",
    },
    pagination_before: {},
    rowsPerPageItems: [5, 10, 25],
    items: [],
    items_complete: [],
    total: 0,
    limit: 10,
    power_plant_id: "",
    competence: "",
    installation_number: "",
    cols: [],
    ucs: [],
    statusList: [
      { value: "atrasada", text: "Atrasados" },
      { value: "overdue", text: "Atrasada" },
      { value: "waiting_payment", text: "Aguardando Pagamento" },
      { value: "opened", text: "Aguardando Pagamento" },
      { value: "refused", text: "Recusado" },
      // { value:'naoprocessado', text: 'Não Processado'},
      { value: "paid", text: "Pagos" },
      { value: "pending", text: "Processando" },
      { value: "reprocessing", text: "Reprocessando" },
    ],
    status: "",
    status_old: "",
    name: "",
    email: "",
    // eslint-disable-next-line no-undef
    last: firestore.DocumentReference,
    last_billing: firestore.DocumentReference,
    before: firestore.DocumentReference,
    data: [
      [
        "Indice",
        "Competencia",
        "Nome",
        // 'UC',
        "Créditos kWh",
        "Consumo kWh",
        "Custo de Disponibilidade kWh",
        "% de Aluguel",
        "Créditos",
        "Mensalidade",
        "Taxa",
        "Receita Liquida",
        "Economia",
        "Saldo",
        "Método de Pagamento",
        "Status",
        "ID do Usuário",
      ],
    ],
    headers: [
      {
        sortable: true,
        text: "Nome",
        value: "name",
      },
      {
        sortable: false,
        text: "Créditos kW",
        value: "item.billing.amount_kW",
      },
      {
        sortable: false,
        text: "%",
        value: "percent",
      },
      {
        sortable: false,
        text: "Créditos",
        value: "amount",
      },
      {
        sortable: false,
        text: "Custo Disp.",
        value: "custo_disp",
      },
      {
        sortable: false,
        text: "Mensalidade",
        value: "total",
      },
      // {
      //     sortable: false,
      //     text: 'Taxa',
      //     value: 'transaction'
      // },
      // {
      //     sortable: false,
      //     text: 'Receita',
      //     value: 'fat'
      // },
      {
        sortable: false,
        text: "Economia",
        value: "discount",
      },
      {
        sortable: true,
        text: "Leitura",
        value: "next_read",
      },
      {
        sortable: false,
        text: "Mét. Pag.",
        value: "transaction.payment_method",
      },
      // {
      //     sortable: false,
      //     text: 'Whatsapp',
      //     value: 'whatsapp'
      // },
      {
        sortable: false,
        text: "Status",
        value: "status",
      },
    ],
  }),
  watch: {
    pagination: {
      // async handler () {
      handler() {
        const {
          // sortBy, descending,
          page,
          rowsPerPage,
        } = this.pagination;

        /* 
            Se selecionou página anterior
            Pega os dados direto do array items_complete
            */
        if (
          this.pagination_before &&
          this.pagination_before.page > this.pagination.page
        ) {
          // console.log('pagina anterior: ', page)
          this.loading = true;
          this.items = this.items_complete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          this.loading = false;

          /*
            Se selecionou proxima página, mas a pagina selecionada já foi carregada antes
            Pega os dados direto do array items_complete
            */
        } else if (
          this.pagination_before &&
          this.pagination_before.page <= this.pagination.page &&
          this.pagination.page <= this.items_complete.length / rowsPerPage
        ) {
          // console.log('próxima pagina: ', page)
          this.loading = true;
          this.items = this.items_complete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          this.loading = false;

          // Se a pagina é a mesma não faz nada
        } else if (this.pagination_before.page === this.pagination.page) {
          // console.log('mesma pagina: ', page)
          return;

          /*
            Se selecionou proxima página, e a pagina selecionada ainda não foi carregada antes
            Busca os dados no firebase e adiciona ao array os dados firebase
            */
        } else {
          // console.log('próxima pagina ainda não carregada: ', page)
          this.pagination_before = this.pagination;
          if (this.last) {
            // console.log('last: ', this.last)
            this.loading = true;
            const {
              // sortBy, descending,
              page,
              rowsPerPage,
            } = this.pagination;
            // await firestore.collection('consumer_units')
            if (this.status !== "") {
              this.getStatus();
            } else {
              this.getBillings();
            }
            if (rowsPerPage > 0) {
              this.items = this.items.slice(
                (page - 1) * rowsPerPage,
                page * rowsPerPage,
              );
            }
          } else {
            this.loading = false;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    eventBus.$on("selectBillingCompetence", async (selected) => {
      this.loading = true;
      this.name = "";
      this.email = "";
      this.status = "";
      this.status_old = "";
      this.items_complete = [];
      this.items = [];
      this.power_plant_id = selected.power_plant_id;
      this.competence = selected.competence;
      this.totalItems = selected.totalItems;
      this.totalItemsInitial = selected.totalItems;
      this.pagination.totalItems = selected.totalItems;

      this.getBillings();
    });
  },
  methods: {
    formatWhatsappPhone(phone) {
      let newphone = phone.replace(/\D/g, "");
      if (newphone.substring(0, 2) !== "55") {
        newphone = "55" + newphone;
      }
      return newphone;
    },
    getUCs(params) {
      let ref = firestore
        .collection("consumer_units")
        .where("power_plant_id", "==", this.power_plant_id);

      if (params.name) {
        ref = ref.where("name_insensitive", ">=", params.name.toLowerCase());
      } else if (params.email) {
        ref = ref.where("email", "==", params.email);
      } else if (params.installation_number) {
        ref = ref.where(
          "installation_number",
          "==",
          params.installation_number,
        );
      } else if (params.status) {
        ref = ref.where("status", "==", params.status);
      }

      if (params.competence) {
        ref = ref.where("billing_competence_start", "<=", params.competence);
        // .where('billing_competence_end', '<=', competence)
      }

      ref = ref.limit(this.pagination.rowsPerPage || 25);

      if (params.name) {
        ref = ref.orderBy(
          "name_insensitive",
          this.pagination.descending ? "desc" : "asc",
        );
      } else if (params.competence) {
        ref = ref.orderBy(
          "billing_competence_start",
          this.pagination.descending ? "desc" : "asc",
        );
      } else {
        // ref = ref.orderBy('created_at', this.pagination.descending?'desc':'asc')
        ref = ref.orderBy(
          "name_insensitive",
          this.pagination.descending ? "desc" : "asc",
        );
      }

      if (this.last) {
        // console.log('param last: ', this.last)
        ref = ref.startAfter(this.last);
      }

      return ref;
    },
    getBilling(competence, customer_id, consumer_unit) {
      return (
        firestore
          .collection("billing")
          .where("competence", "==", competence)
          .where("customer_id", "==", customer_id)
          .where("consumer_unit", "==", consumer_unit)
          // .limit(1)
          .get()
      );
      // .then(billings => {
      //     if(billings.size > 0) {
      //         const billing = billings.docs[0]
      //         return {
      //             id: billing.id,
      //             ...billing.data()
      //         }
      //     } else {
      //         return null
      //     }
      // })
    },
    url(item) {
      const creditos = item.tarifa;
      const desconto_indicacao = item.referral_balance
        ? item.referral_balance
        : 0;
      const valor_desconto = item.tarifa - item.billing.total;
      const custo_disp = item.custo_disp ? item.custo_disp : 0;
      let pagamento = 0;
      let economia = 0;
      if (item.billing.competence > "2020-01") {
        pagamento = item.billing.total;
        economia = item.billing.discount + desconto_indicacao;
      } else {
        if (item.power_plant_id === "ufvpedralva1") {
          pagamento = creditos - valor_desconto - desconto_indicacao;
        } else {
          pagamento =
            creditos - custo_disp - valor_desconto - desconto_indicacao;
        }
        economia = item.billing.discount + desconto_indicacao;
      }
      const valor = this.formatCurrencyEmail(pagamento);
      const competencia =
        item.billing.competence.split("-")[1] +
        "/" +
        item.billing.competence.split("-")[0];
      economia = this.formatCurrencyEmail(economia);
      let message = "";
      // let url = 'https://web.whatsapp.com/send?phone='+this.formatWhatsappPhone(item.user.phone)+'&text='
      let url = "";
      let nome = item.name ? item.name.split(" ")[0] : "";
      message =
        "*Parabéns " +
        nome +
        "!* Você economizou *R$ " +
        economia +
        "* no mês de " +
        competencia +
        " em sua conta de energia. Faça seu pagamento no valor de *R$ " +
        valor +
        "* usando o código " +
        item.billing.transaction.boleto_barcode +
        " ou baixe seu boleto em " +
        item.billing.transaction.boleto_url +
        ". Acesse agora nossos aplicativos para ver o detalhamento de sua fatura.";
      return encodeURI(url + message);
    },
    gotoUserDetail(item) {
      eventBus.$emit("user_detail", item);
      eventBus.$emit("rightcustomerdetail", true);
    },
    gotoTransactionHistory(transaction_id) {
      eventBus.$emit("billing_id", transaction_id);
      eventBus.$emit("right", true);
      // this.$router.replace(`/transaction/${transaction_id}`)
    },
    formatStatus(status) {
      if (status === "") return "";
      if (status === "pending") return "Aguardando Pagamento";
      if (status === "paid") return "Fatura Paga";
      if (status === "succeeded") return "Fatura Paga";
      if (status === "failed") return "Falha ao realizar cobrança";
      if (status === "processing")
        return "Transação está em processo de autorização.";
      if (status === "authorized")
        return "Transação foi autorizada. Cliente possui saldo na conta e este valor foi reservado para futuro faturamento.";
      if (status === "refunded") return "Transação estornada completamente.";
      if (status === "waiting_payment" || status === "opened")
        return "Aguardando pagamento.";
      if (status === "overdue") return "Atrasado.";
      if (status === "refused")
        return "Transação recusada, não autorizada. Por favor, entre em contato conosco.";
      if (status === "analyzing")
        return "Transação encaminhada para a análise manual feita por um especialista em prevenção a fraude.";
      if (status === "pending_review")
        return "Transação pendente de revisão manual.";
    },
    formatColor(billing) {
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() - 1);
      if (billing.status === "refused") return "orange";
      if (billing.status === "overdue") return "red";
    },
    async _clear(search) {
      this.loading_search = true;
      this.items = [];
      this.items_complete = [];
      this.last = null;
      this.last_billing = null;
      this.pagination_before = {};
      this.name = "";
      this.email = "";
      this.status = "";
      this.status_old = "";
      this.totalItems = this.totalItemsInitial;
      if (search) {
        this._search();
      }
    },
    getBillings() {
      let params = {};
      if (this.name) {
        params.name = this.name;
      } else if (this.email) {
        params.email = this.email;
      } else if (this.power_plant_id) {
        params.power_plant_id = this.power_plant_id;
      } else if (this.installation_number) {
        params.installation_number = this.installation_number;
      } else if (this.last) {
        params.last = this.last;
      }
      if (this.competence) params.competence = this.competence;

      this.getUCs(params)
        .get()
        .then((ucs) => {
          this.last = ucs.docs[ucs.docs.length - 1];
          // console.log('ucs size: ', ucs.size)
          ucs.docs.map(async (snapshot, index) => {
            if (snapshot.data().user_id) {
              // console.log('user_id: ', snapshot.data().user_id)
              await this.getBilling(
                this.competence,
                snapshot.data().user_id,
                snapshot.id,
              ).then((billings) => {
                // console.log('size: ', billings.size)
                if (billings.size > 0) {
                  billings.docs.map((billing) => {
                    const data = {
                      index,
                      id: snapshot.id,
                      ...snapshot.data(),
                      billing: {
                        id: billing.id,
                        ...billing.data(),
                      },
                    };
                    // console.log('data: ', data)
                    this.items.push(data);
                    this.items_complete.push(data);
                  });
                } else {
                  const data = {
                    index,
                    id: snapshot.id,
                    ...snapshot.data(),
                    // billing: {
                    //     id: billing.id,
                    //     ...billing.data()
                    // }
                  };
                  this.items.push(data);
                  this.items_complete.push(data);
                }
              });
              // const billing = await this.getBilling(this.competence, snapshot.data().user_id)
              // const data = {
              //     index,
              //     id: snapshot.id,
              //     ...snapshot.data(),
              //     billing
              // }
              // this.items.push(data)
              // this.items_complete.push(data)
            } else {
              return;
            }
            if (ucs.size - 1 === index) {
              // console.log(this.items)
              this.loading = false;
            }
          });
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    async getStatus() {
      if (this.status_old !== this.status) {
        this.last_billing = null;
        this.status_old = this.status;
      }

      let refBilling = firestore
        .collection("billing")
        .where("power_plant_id", "==", this.power_plant_id)
        .where("competence", "==", this.competence)
        .where(
          "status",
          "==",
          this.status === "atrasada" ? "waiting_payment" : this.status,
        )
        .limit(this.pagination.rowsPerPage || 25);

      if (this.last_billing) {
        refBilling = refBilling.startAfter(this.last_billing);
      }

      await refBilling.get().then((billings) => {
        if (billings.size > 0) {
          if (billings.size < this.pagination.rowsPerPage) {
            this.totalItems =
              (this.pagination.page - 1) * this.pagination.rowsPerPage +
              billings.size;
            this.pagination.totalItems = this.totalItems;
          } else {
            this.totalItems = this.totalItemsInitial;
          }
          this.last_billing = billings.docs[billings.docs.length - 1];
          billings.docs.map(async (billing, index) => {
            if (billing.data().consumer_unit) {
              const uc = await firestore
                .collection("consumer_units")
                .doc(billing.data().consumer_unit)
                .get();
              let data = {};
              if (this.status === "atrasada" && billing.data().transaction) {
                let tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() - 1);
                let venc = new Date(
                  billing.data().transaction.boleto_expiration_date,
                );
                if (venc.getTime() < tomorrow.getTime()) {
                  data = {
                    index,
                    id: uc.id,
                    ...uc.data(),
                    billing: billing.data(),
                  };
                }
              } else {
                data = {
                  index,
                  id: uc.id,
                  ...uc.data(),
                  billing: billing.data(),
                };
              }
              if (data.id) {
                this.items.push(data);
                this.items_complete.push(data);
              }
            } else {
              this.items = [];
              this.items_complete = [];
            }
            if (billings.size - 1 === index) {
              this.loading = false;
              this.loading_search = false;
            }
          });
        } else {
          this.items = [];
          this.items_complete = [];
          this.loading_search = false;
        }
      });
    },
    async _search() {
      this.loading_search = true;
      this.items = [];
      this.items_complete = [];
      const {
        // sortBy,
        page,
        rowsPerPage,
      } = this.pagination;

      let params = {};
      if (this.name) {
        params.name = this.name;
      } else if (this.email) {
        params.email = this.email;
      } else if (this.status) {
        params.status = this.status;
      } else if (this.installation_number) {
        params.installation_number = this.installation_number;
      }
      params.competence = this.competence;
      let ref = await this.getUCs(params);

      if (this.status !== "") {
        this.getStatus();
      } else {
        ref
          .get()
          .then((ucs) => {
            if (ucs.size > 0) {
              this.last = ucs.docs[ucs.docs.length - 1];
              ucs.docs.map(async (snapshot, index) => {
                if (snapshot.data().user_id) {
                  const billing = await this.getBilling(
                    this.competence,
                    snapshot.data().user_id,
                    snapshot.id,
                  );
                  const data = {
                    index,
                    id: snapshot.id,
                    ...snapshot.data(),
                    billing,
                  };
                  this.items.push(data);
                  // this.items_complete.push(data)
                }
                if (ucs.size - 1 === index) {
                  this.loading_search = false;
                }
              });
            } else {
              this.loading_search = false;
            }
          })
          .catch((error) => {
            console.error(error);
            this.loading_search = false;
          });
      }
      this.pagination = {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: null,
        totalItems: this.totalItems,
      };

      if (rowsPerPage > 0) {
        this.items = this.items.slice(
          (page - 1) * rowsPerPage,
          page * rowsPerPage,
        );
      }
    },
    _export(items) {
      /* convert state to workbook */
      items.forEach((item, index) => {
        item.id = index;
        /*
                var ucs = [];
                item.consumer_units.forEach(uc => {
                    ucs.push(uc.consumer_unit)
                })
                */
        let taxa = 0;
        let receita = 0;
        let total_consumo_kW = 0;
        let valor_kwh =
          (item.billing.amount * 1) / (item.billing.amount_kW * 1) || 1;
        if (item.billing.transaction && item.billing.competence < "2019-07") {
          taxa = item.billing.transaction.cost;
          receita = item.billing.total - item.billing.transaction.cost;
          total_consumo_kW = parseInt(
            (item.billing.total_utility_company * 1) / valor_kwh,
          );
        } else {
          if (
            item.billing.transactionPagarme &&
            item.billing.transactionPagarme.payables
          ) {
            taxa =
              this.sumFee(item.billing.transactionPagarme.payables) +
              (item.billing.transactionPagarme.payment_method === "credit_card"
                ? item.billing.transactionPagarme.cost / 100
                : 0);
            receita =
              item.billing.total -
              (this.sumFee(item.billing.transactionPagarme.payables) +
                (item.billing.transactionPagarme.payment_method ===
                "credit_card"
                  ? item.billing.transactionPagarme.cost / 100
                  : 0));
          } else {
            taxa = 0;
            receita = 0;
          }
          total_consumo_kW = parseInt(
            (item.tarifa * 1 || item.billing.total_utility_company * 1) /
              valor_kwh,
          );
        }
        this.data.push([
          index + 1,
          item.billing.competence,
          item.name || 0,
          // ucs,
          item.billing.amount_kW * 1,
          total_consumo_kW / valor_kwh || 0,
          parseInt(item.custo_disp / valor_kwh) || 0,
          item.billing.amount_kW / this.total,
          item.billing.amount * 1,
          item.billing.total * 1,
          taxa * 1 || 0,
          receita * 1 || 0,
          item.billing.discount * 1,
          item.balance || 0,
          item.billing.transaction
            ? item.billing.transaction.payment_method
            : "" || "",
          item.billing.status || "",
          item.customer_id,
        ]);
      });
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();

      const file = "faturamento_" + this.formatFileName(new Date());
      // XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      XLSX.utils.book_append_sheet(wb, ws, file);
      /* generate file and send to client */
      XLSX.writeFile(wb, file + ".xlsx");
    },
    formatFileName(value) {
      if (!value) return "";
      const year = value.getYear();
      const month = value.getMonth() + 1;
      const day = value.getDay();
      const hour = value.getHours();
      const minute = value.getMinutes();
      return day + "" + month + "" + year + "" + hour + "" + minute;
    },
    sumFee(value) {
      if (!value || value.length === 0) return 0;
      var sum = value.reduce(function (sum, elem) {
        return sum + elem.fee;
      }, 0);
      return sum / 100;
    },
    formatCurrencyEmail(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  filters: {
    formatCurrency(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatPercent(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val;
    },
    formatStatus: function (value) {
      if (!value) return "";

      if (value === "paga" || value === "succeeded" || value === "paid") {
        return "done_outline";
      } else if (
        value === "aberta" ||
        value === "pending" ||
        value === "waiting_payment" ||
        value === "opened"
      ) {
        return "schedule";
      } else if (value === "free") {
        return "free_breakfast";
      } else {
        return "error";
      }
    },
    formatPaymentType: function (value) {
      if (!value) return "";

      if (value === "credit" || value === "credit_card") return "credit_card";
      else return "mdi-barcode";
    },
    formatName: function (value) {
      if (!value) return "";
      if (value.length > 25) {
        return value.substr(0, 25) + "...";
      } else {
        return value;
      }
    },
    sumFee(value) {
      if (!value || value.length === 0) return 0;
      var sum = value.reduce(function (sum, elem) {
        return sum + elem.fee;
      }, 0);
      return sum / 100;
    },
    formatNextRead(value) {
      if (!value) return "";
      let date = value.toDate();
      return moment(date).format("DD/MM");
    },
  },
  // computed: {
  //   pages () {
  //     if (this.pagination.rowsPerPage == null ||
  //       this.pagination.totalItems == null
  //     ) return 0

  //     // return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
  //     return Math.ceil(100 / 10)
  //   }
  // }
};
</script>

<style scoped>
.canceling {
  color: orange;
  font-style: unset;
}
.canceled {
  color: red;
  font-style: unset;
}
</style>
